module.exports = __webpack_public_path__ + "static/media/basketIcon.9299d4d1.svg";